import { SVGProps } from 'react'

const MoneyCircle = (props: SVGProps<any>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}>
      <path
        d="M14.6666 8.00065C14.6666 11.6825 11.6818 14.6673 7.99992 14.6673C4.31802 14.6673 1.33325 11.6825 1.33325 8.00065C1.33325 4.31875 4.31802 1.33398 7.99992 1.33398C11.6818 1.33398 14.6666 4.31875 14.6666 8.00065Z"
        fill="currentColor"
      />
      <path
        d="M7.67 4.73V3.91H8.29V4.73C8.89 4.77 9.36 4.94 9.72 5.23C10.13 5.55 10.38 6.08 10.48 6.8H9.42C9.36 6.37 9.2 6.06 8.95 5.88C8.78 5.75 8.56 5.67 8.29 5.64V7.93C9.03 8.21 9.46 8.38 9.56 8.42C10.25 8.81 10.6 9.36 10.6 10.08C10.6 10.79 10.33 11.32 9.81 11.68C9.41 11.94 8.91 12.09 8.29 12.13V13.01H7.67V12.13C6.99 12.09 6.47 11.89 6.11 11.54C5.69 11.14 5.46 10.54 5.4 9.72H6.48C6.52 10.26 6.65 10.65 6.89 10.88C7.07 11.06 7.33 11.17 7.67 11.21V8.77L6.54 8.35C5.84 7.98 5.49 7.43 5.49 6.69C5.49 6.04 5.74 5.54 6.24 5.19C6.62 4.91 7.09 4.76 7.67 4.73ZM8.29 8.99V11.21C8.61 11.17 8.87 11.08 9.09 10.94C9.37 10.74 9.52 10.47 9.52 10.12C9.52 9.66 9.17 9.3 8.47 9.06C8.41 9.04 8.35 9.01 8.29 8.99ZM7.67 7.7V5.63C7.39 5.65 7.16 5.73 6.99 5.85C6.71 6.03 6.58 6.31 6.58 6.69C6.58 7.1 6.93 7.43 7.63 7.69C7.64 7.69 7.65 7.7 7.67 7.7Z"
        fill="#272727"
      />
    </svg>
  )
}

export default MoneyCircle
